import React, {useEffect, useState} from 'react';
import {LoadingButton} from '@mui/lab';
import {Button, Menu, MenuItem, Stack, useTheme} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import dayjs from 'dayjs';
import {useFormContext} from 'react-hook-form';

const DateRangeSelector = (props: any) => {
  const theme = useTheme();
  const {setValue, watch} = useFormContext();
  const values = watch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (range: any) => {
    setValue('from_date', range.from);
    setValue('to_date', range.to);
    props?.setParentState((prevState: any) => ({
      ...prevState,
      from_date: range.from,
      to_date: range.to
    }));
    handleClose();
  };

  const generateDefaultDateRange = (category: string, label: string) => {
    switch (category) {
      case 'collections':
        return {label: label, from: dayjs().subtract(4, 'months'), to: dayjs()};
      case 'payments':
        return {label: label, from: dayjs().subtract(6, 'months'), to: dayjs()};
      case 'kpi':
        return {label: label, from: dayjs().subtract(1, 'months'), to: dayjs()};
      default:
        return {label: label, from: dayjs().subtract(6, 'months'), to: dayjs()};
    }
  };

  const predefinedRanges = [
    generateDefaultDateRange(
      values?.category?.toLowerCase(),
      'Default Date Range'
    ),
    {label: 'Last 7 Days', from: dayjs().subtract(7, 'day'), to: dayjs()},
    {label: 'Last 30 Days', from: dayjs().subtract(30, 'day'), to: dayjs()},
    {label: 'Last 60 Days', from: dayjs().subtract(60, 'day'), to: dayjs()},
    {label: 'Last Year', from: dayjs().subtract(1, 'year'), to: dayjs()}
  ];

  useEffect(() => {
    handleMenuItemClick(predefinedRanges[0]);
  }, [values.category]);

  return (
    <Stack direction="row" alignItems="center" sx={{mx: 2}}>
      {/* Default Date Button */}
      <LoadingButton
        type="reset"
        variant="outlined"
        onClick={() => handleMenuItemClick(predefinedRanges[0])}
        loading={props?.isSubmitting}
        disabled={props?.searchLoader}
        sx={{
          bgcolor: theme.palette.primary.dark,
          borderTopRightRadius: 'inherit !important',
          borderBottomRightRadius: 'inherit !important',
          color: 'white',
          '&:hover': {bgcolor: theme.palette.primary.darker}
        }}>
        Default Date Range
      </LoadingButton>

      {/* Dropdown Button */}
      {predefinedRanges.length > 1 && (
        <>
          <Button
            disabled={props.searchLoader}
            sx={{
              bgcolor: theme.palette.primary.dark,
              color: 'white',
              borderTopLeftRadius: 'inherit !important',
              borderBottomLeftRadius: 'inherit !important',
              minWidth: '10px',
              maxWidth: '10px',
              '&:hover': {bgcolor: theme.palette.primary.darker}
            }}
            aria-controls={open ? 'date-range-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="menu"
            onClick={handleClick}>
            <ArrowDropDownIcon />
          </Button>

          {/* Dropdown Menu */}
          <Menu
            id="date-range-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}>
            {predefinedRanges.map(range => (
              <MenuItem
                key={range.label}
                onClick={() => handleMenuItemClick(range)}>
                {range.label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Stack>
  );
};

export default DateRangeSelector;
